// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2632) return "static/chunks/2632-5f0c7ebbd53bef7a.js";
	if (chunkId === 864) return "static/chunks/864-b88b563f0b45a01d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"0":"f831b9e9d751d48a","555":"5942039209bcb4e7","991":"8773f48a75a7f3e0","2009":"59f59bf98b53475f","4360":"845349145116a83e","6242":"b2c61bf25f073a16","7867":"d87477aa13b491c9","8643":"a15057d39e373256","9491":"a040309b68af679c"}[chunkId] + ".js";
};